import React from "react";
import { Checkbox as ChakraCheckbox, CheckboxProps } from "@chakra-ui/react";

const Checkbox = ({ ...props }: CheckboxProps) => {
  return <ChakraCheckbox {...props}>{props.children}</ChakraCheckbox>;
};

export default Checkbox;
